import GiftGivingReport from '@/pages/GiftGivingReport';

export default {
    path: '/relacja-z-wreczenia-paczki/:familyId',
    component: GiftGivingReport,
    name: 'gift_giving_report',
    meta: { requiresAuth: true }
};
